import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { DocumentoDet } from 'src/app/models/DocumentoDet';
import { ngClassAceptarModal, ngClassSalirModal, isEmptyList, openModalMensaje, isEmpty } from 'src/app/general/variables';
import { EvidenciasComponent } from '../../denuncia/evidencias/evidencias.component';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';

@Component({
  selector: 'app-modal-reg-cargo',
  templateUrl: './modal-reg-cargo.component.html',
  styleUrls: ['./modal-reg-cargo.component.css']
})
export class ModalRegCargoComponent implements OnInit {

  strDscEtiqueta1 = 'Fecha de Recepción física';
  documentoDet: DocumentoDet = new DocumentoDet();
  flgLectura = false;
  // listDocumentoDet:DocumentoDet[] = [];

  ngClassAceptarModal = ngClassAceptarModal;
  ngClassSalirModal = ngClassSalirModal;

  @ViewChild('evidenciaCargo') evidenciasC: EvidenciasComponent;
  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor( private dialogRef: MatDialogRef<ModalRegCargoComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any,
               public dialog: MatDialog) { }

  ngOnInit() {

    let vListCargo: DocumentoDet[] = [];

    this.navModalC.setDatosNavModal2('Detalle de Cargos');

    // {documento : documentoDet, tipoFicha:this.strCodTipoFicha, subTipoFicha:this.strCodSubTipoFicha, numIdTipo:this.numIdTipoFicha}

    console.log('=============this.data.documento');
    console.log(this.data.documento);

    this.documentoDet = this.data.documento;
    vListCargo = this.documentoDet.listaCargo;

    vListCargo = (isEmptyList(vListCargo) ? [] : vListCargo);

    setTimeout(() => {

      this.evidenciasC.setStrIdBtnFile('input_file1');

      this.evidenciasC.setStrDscEtiqueta1('Adjuntar Cargo');
      this.evidenciasC.setEvidenciaGeneral(vListCargo);

      // this.evidenciasC.setFlgModoOutput(true);

      this.evidenciasC.setFichaDocumento(this.data.tipoFicha, this.data.subTipoFicha, this.data.numIdTipo);

    }, 0);

  }

  // _cargarEvidenciaOut(documento:DocumentoDet){

  //   console.log("_cargarEvidenciaOut");

  //   this.evidenciasC.setPushEvidenciaC2(documento);

  // }

  _cerrarModal() {

    this.dialogRef.close();

  }

  _aceptar() {

    const vListDoc: DocumentoDet[] = this.evidenciasC.getEvidenciasC();

    console.log('========vListDoc');
    console.log(vListDoc);

    if (isEmpty(this.documentoDet.strDdocumentoFchrecep) ) {

      openModalMensaje('Cargo', 'Debe ingresar la fecha de recepción, por favor verifique', this.dialog);

      return;

    }


    if (isEmptyList(vListDoc) ) {

      openModalMensaje('Cargo', 'Debe adjuntar documentos, por favor verifique', this.dialog);

      return;

    }

    this.documentoDet.listaCargo = vListDoc;

    this.dialogRef.close(this.documentoDet);

  }

  _cambioFecha(e: any) {

    let vStrFecha: string = e.target.value;
    const vCantCadena = vStrFecha.length;

    if (vCantCadena > 10) {

      vStrFecha = vStrFecha.substr(vCantCadena - 10);

    }

    e.target.value = vStrFecha;

  }


}
